<template>
  <div class="row mt-4">
    <div class="col-12">
      <div class="card ficha-listado">
        <div class="px-4 pb-4 card-body">
          <div class="mb-3">
            <h6 class="mb-0">Evolución de suscriptores</h6>
            <p class="text-xs opacity-7 mb-0">
              Altas, bajas y variación neta en el periodo ·
              <span v-if="tipsterLabel">{{ tipsterLabel }}</span>
              <span v-else>todos los tipsters</span>
              <span class="evo-nota-agg" v-if="tipsterLabel"> (datos agregados de todas las campañas)</span>
            </p>
          </div>

          <QuantySuscriptoresChart
            v-if="evolucion.length"
            id="pub-evolucion-chart"
            :labels="labels"
            :altas="altas"
            :bajas="bajas"
            :acumulado="acumulado"
          />
          <div v-else class="sin-datos-periodo">
            Sin datos para el periodo seleccionado
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuantySuscriptoresChart from "@/components/charts/QuantySuscriptoresChart.vue";

const MESES = ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"];
function fmtMes(s) {
  const [y, m] = s.split("-");
  return `${MESES[parseInt(m) - 1]} '${String(y).slice(2)}`;
}

export default {
  name: "PanelPublicistaEvolucion",
  components: { QuantySuscriptoresChart },
  props: {
    evolucion:     { type: Array,  default: () => [] },
    tipsterLabel:  { type: String, default: '' },
  },
  computed: {
    labels()    { return this.evolucion.map(r => fmtMes(r.mes)); },
    altas()     { return this.evolucion.map(r => r.altas); },
    bajas()     { return this.evolucion.map(r => r.bajas); },
    acumulado() {
      let sum = 0;
      return this.evolucion.map(r => { sum += r.altas - r.bajas; return sum; });
    },
  },
};
</script>

<style scoped>
.evo-nota-agg { opacity: .65; font-style: italic; }
.sin-datos-periodo {
  text-align: center;
  padding: 32px 0;
  color: var(--q-text-muted);
  font-size: 13px;
  opacity: 0.7;
}
</style>
